import { customerCareEmail, mailTo } from '.';
import { faq, returnsPolicy } from './routes';

/* eslint-disable max-len */
const shippingAndReturns = (currencySymbol, buildUrlWithCountry) =>
  [
    'This product will be shipped directly from the boutique to you from Italy. italist ships worldwide, and you will be able to track your order any time. The cost of shipping your order will be calculated at the checkout.',
    `Delivery duties will be calculated at the checkout when shipping worldwide. This means all import duties are included in your order, so the price you see is the price you pay. You will not have to pay additional taxes and fees when you receive your package. ${
      currencySymbol === 'USD'
        ? ''
        : 'Please note that for shipping to countries outside of the E.U., VAT (value added tax) is not charged.'
    }`,
    `${
      currencySymbol === 'USD'
        ? ''
        : 'Delivery duties are not calculated when shipping to: Angola, Armenia, Azerbaijan, Belarus, Cambodia, Cape Verde, Central African Republic, Chad, Comoros, Cook Islands, Falkland Islands (Malvinas), Faroe Islands, Gambia, Georgia, Greenland, Guinea, Guinea-Bissau, Kazakhstan, Kiribati, Kyrgyzstan, Lesotho, Liberia, Lithuania, Macedonia, Malawi, Mali, Marshall Islands, Mauritania, Mayotte, Moldova, Montenegro, Mozambique, Namibia, Nauru, Nigeria, Niue, Northern Mariana Islands, Russia, Samoa, Sao Tome and Principe, Seychelles, Solomon Islands, Somalia, Suriname, Swaziland, Tajikistan, Tonga, Tunisia, Tuvalu, Uzbekistan, Vanuatu, Yemen, Zambia. This means you may be liable to pay import duties on receipt of your order.'
    }`,
    `You can request a return within 14 days of receiving your order. We strongly recommend that you book your returns pick-up within 10 days of receiving your order to ensure that it arrives back to the boutique in time. Please note we can only collect returns from the same country to which your order was delivered. Click <a href=${buildUrlWithCountry(
      returnsPolicy,
    )}>here</a> to read our full returns policy.`,
  ].filter(x => x);
/* eslint-enable max-len */

const contactUs = buildUrlWithCountry =>
  `Questions? Contact us at <a href="${mailTo(
    customerCareEmail,
  )}">${customerCareEmail}</a> or browse our <a href="${buildUrlWithCountry(
    faq,
  )}" class="product-faq-link">FAQ</a> page.`;

export default function generateProductDetailsDescriptionData(
  description,
  sizeAndFitting,
  currencySymbol,
  buildUrlWithCountry,
) {
  const arr = [];

  arr.push(generateDataElement('Description', description));
  sizeAndFitting && arr.push(generateDataElement('Size and Fit', sizeAndFitting));
  arr.push(generateDataElement('Shipping and Returns', shippingAndReturns(currencySymbol, buildUrlWithCountry)));
  arr.push(generateDataElement('Contact us', contactUs(buildUrlWithCountry)));

  return arr;
}

function generateDataElement(title, text) {
  return { title, text };
}
